export default "__VITE_ASSET__2d33a123__"